import React, { ReactNode, FC, useCallback } from 'react';
import { WithTranslation } from 'react-i18next';

import { StyledErrorBoundary } from './AppErrorBoundary.styles';

export interface AppErrorBoundaryProps {
  /** The content to display when there is no error. */
  children?: ReactNode;
  /** Custom error message. */
  message?: ReactNode;
  /** Custom title of the error. */
  errorTitle?: ReactNode;
  /** Customtext of the retry button. If not defined, no error button will display. */
  retryButton?: ReactNode;
}

const AppErrorBoundary: FC<AppErrorBoundaryProps & WithTranslation> = ({ errorTitle, children, message, t, retryButton }) => {
  const handleRetry = useCallback(() => window.location.reload(), []);

  return (
    <StyledErrorBoundary
      data-testid="AppErrorBoundary"
      errorTitle={errorTitle || t('loadingError.title')}
      message={message || t('loadingError.message')}
      retryButton={retryButton || t('loadingError.retryButton')}
      onRetry={handleRetry}
    >
      {children}
    </StyledErrorBoundary>
  );
};

export default AppErrorBoundary;
